<template>
  <div class="page-footer">
    <section class="footer-color-bar">
      <h3>探索未知之境</h3>
      <p>运动无限，把整个城市当做一个大运动场，探索更多未知的可能</p>
    </section>
    <section class="footer-info">
      <b-container fluid="xl">
        <b-row>
          <b-col cols="6" xl="4" md="4" sm="6" class="info-item">
            <header>CONTACTS</header>

            <p class="mb-4">上海市奉贤区青村镇青高路890号1幢</p>

            <div class="blod-info mb-4">
              <img src="../assets/imgs/phone.png" alt="" />
              13168819073
            </div>

            <div class="blod-info">
              <img src="../assets/imgs/mail.png" alt="" />
              chuangzhihe2021@126.com
            </div>
            <br/>
            <a href="https://beian.miit.gov.cn/" style="text-decoration:none; color:#000000;" target="view_window"> 沪ICP备2021027634号</a>
          </b-col>

          <b-col cols="6" xl="4" md="4" sm="6" class="info-item">
            <header>Company</header>

            <p> 上海创之河信息科技有限公司</p>

          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style scoped lang="scss">
  .page-footer {
    padding-bottom: 86px;
    .footer-color-bar {
      height: 195px;
      background: linear-gradient(165deg, #272a35, #272a35);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 20px;

      h3 {
        font-size: 22px;
        font-weight: 700;
        color: #ffffff;
      }

      p {
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.4;
        margin-top: 13px;
      }
    }

    .footer-info {
      padding-top: 78px;

      .info-item {
        header {
          font-size: 18px;
          font-weight: 700;
          color: #000000;
          margin-bottom: 50px;
        }

        p {
          font-size: 15px;
          font-weight: 400;
          color: #000000;
        }

        .blod-info {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-weight: 700;
          color: #000000;

          img {
            width: 18px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .footer-color-bar {
      text-align: center;
      h3 {
        font-size: 16px !important;
      }
      p {
        font-size: 12px !important;
      }
    }
  }
</style>
